// Copyright (c) Microsoft. All rights reserved.

import { FC, useState } from 'react';

import {
    Button,
    // Divider,
    // Menu,
    // MenuItem,
    // MenuList,
    // MenuPopover,
    // MenuTrigger,
    Tooltip,
    makeStyles,
    // mergeClasses,
} from '@fluentui/react-components';
import { useChat } from '../../../../libs/hooks';
import { useAppSelector } from '../../../../redux/app/hooks';
import { RootState } from '../../../../redux/app/store';
// import { FeatureKeys } from '../../../../redux/features/app/AppState';
import { Add20 } from '../../../shared/BundledIcons';
import { InvitationJoinDialog } from '../../invitation-dialog/InvitationJoinDialog';
import { Breakpoints, customTokens } from '../../../../styles';
import { TemperatureType } from '../../../../libs/models/TemperatureType';

interface SimplifiedNewBotMenuProps {
    onFileUpload: () => void;
}

const useClasses = makeStyles({
    root: {
        ...Breakpoints.small({
            display: 'none',
        }),
    },
    addChats: {
        display: 'block',
    },
    creative: {
        backgroundColor: customTokens.creative,
        color: '#fff',
        '&:hover': {
            backgroundColor: customTokens.creativeLight,
            color: '#fff',
        },
    },
    balanced: {
        backgroundColor: customTokens.balanced,
        color: '#fff',
        '&:hover': {
            backgroundColor: customTokens.balancedLight,
            color: '#fff',
        },
    },
    precise: {
        backgroundColor: customTokens.precise,
        color: '#fff',
        '&:hover': {
            backgroundColor: customTokens.preciseLight,
            color: '#fff',
        },
    },
});

export const SimplifiedNewBotMenu: FC<SimplifiedNewBotMenuProps> = () => {
    const classes = useClasses();
    const chat = useChat();
    const { activeUserInfo } = useAppSelector((state: RootState) => state.app);
    const { conversations, selectedId } = useAppSelector((state: RootState) => state.conversations);

    const temperature: TemperatureType = conversations[selectedId].temperature ?? TemperatureType.Balanced;
    //  const { features } = useAppSelector((state: RootState) => state.app);

    // It needs to keep the menu open to keep the FileUploader reference
    // when the file uploader is clicked.
    const [isJoiningBot, setIsJoiningBot] = useState(false);

    const onAddChat = () => {
        void chat.createChat();
    };
    // const onJoinClick = () => {
    //     setIsJoiningBot(true);
    // };

    const onCloseDialog = () => {
        setIsJoiningBot(false);
    };

    const getTemperatureClass = () => {
        switch (temperature) {
            case TemperatureType.Creative:
                return 'creative';
            case TemperatureType.Balanced:
                return 'balanced';
            case TemperatureType.Precise:
                return 'precise';
            default:
                return 'balanced';
        }
    };

    return (
        <div className={activeUserInfo?.isMenuOpen ? classes.addChats : classes.root}>
            <Tooltip content="Add a Topic" relationship="label">
                <Button
                    data-testid="createNewConversationButton"
                    icon={<Add20 />}
                    className={classes[getTemperatureClass()]}
                    onClick={onAddChat}
                >
                    {'New Topic'}
                </Button>
            </Tooltip>
            {/* <Menu>
                <MenuTrigger disableButtonEnhancement>
                    <Tooltip content="Add a chat" relationship="label">
                        <Button data-testid="createNewConversationButton" icon={<Add20 />} appearance="transparent" />
                    </Tooltip>
                </MenuTrigger>
                <MenuPopover>
                    <MenuList>
                        <MenuItem data-testid="addNewBotMenuItem" onClick={onAddChat}>
                            New Chat Session
                        </MenuItem>
                        <Divider />
                        <MenuItem
                            data-testid="joinABotMenuItem"
                            disabled={!features[FeatureKeys.MultiUserChat].enabled}
                            onClick={onJoinClick}
                        >
                            Join Shared Chat
                        </MenuItem>
                    </MenuList>
                </MenuPopover>
            </Menu> */}
            {isJoiningBot && <InvitationJoinDialog onCloseDialog={onCloseDialog} />}
        </div>
    );
};
